<script>
import Layout from '@layout/main'

export default {
  components: {
    Layout,
  },
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
    img: {
      type: String,
      default: '@assets/images/investor/index_banner.jpg',
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeMenu: this.menuList[0].title,
      scrollTop: 0,
    }
  },
  computed: {
    isMenuFixed() {
      return this.scrollTop > 381
    },
  },
  mounted() {
    const initActiveMenu = () => {
      const activeMenuItem = this.menuList.filter((item) => {
        return item.name === this.$route.name
      })

      this.activeMenu = activeMenuItem.length > 0 ? activeMenuItem[0].title : this.menuList[0].title
    }

    initActiveMenu()
    this.onScroll()
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.scrollTop = this.getWindowScrollTop()
    },
    getWindowScrollTop() {
      let windowScrollTop = 0

      if (typeof window.pageYOffset !== 'undefined') {
        windowScrollTop = window.pageYOffset
      } else if (typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
        windowScrollTop = document.documentElement.scrollTop
      } else if (typeof document.body !== 'undefined') {
        windowScrollTop = document.body.scrollTop
      }

      return windowScrollTop
    },
    onChangeMenu() {
      const activeMenuItem = this.menuList.filter((item) => {
        return item.title === this.activeMenu
      })
      if (activeMenuItem.length > 0) {
        this.$router.push({ name: activeMenuItem[0].name })
      } else {
        this.$router.push({ name: this.menuList[0].title.name })
      }
    },
  },
}
</script>
<template>
  <Layout>
    <div :class="$style.sectionMenuList">
      <div :class="[$style.brandCover, customClass]">
        <div class="brandCover__cover">
          <div class="brandCover__parallax">
            <div class="brandCover__image" :style="{ backgroundImage: `url(${img})` }"> </div>
          </div>
          <div class="container position-relative h-100 brandCover__BoxInner">
            <BaseBreadcrumb class="brandCover__breadcrumb" :custom-class="customClass" />
            <h2 class="brandCover__title font-medium">{{ activeMenu }}</h2>
          </div>
        </div>
        <!-- <BaseBanner title="公司簡介" :image="require('@assets/images/about/banner.jpg')"/>  -->
        <div class="container sectionMenuList__BoxInner" :class="{ isFixed: isMenuFixed, isMobileStyle: menuList.length > 3 }">
          <div class="row sectionMenuList__list no-gutters">
            <router-link v-for="(item, $index) in menuList" :key="$index" class="text-center sectionMenuList__item col" :to="{ name: item.name }">
              {{ item.title }}
            </router-link>
          </div>
          <div class="sectionMenuList__selectBox">
            <el-select v-model="activeMenu" class="isStyleMenu isCenter" popper-class="isStyleMenu isCenter" @change="onChangeMenu">
              <template v-for="(menuItem, index) in menuList">
                <el-option :key="menuItem.title" :label="menuItem.title" :value="menuItem.title"> </el-option>
              </template>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <slot />
  </Layout>
</template>
<style lang="scss" module>
.sectionMenuList {
  // background: #fff;
  box-shadow: 0 10px 20px rgba(33, 69, 88, 0.1);

  @include max-md {
    // margin-top: 1rem;
    background: transparent;
    box-shadow: none;
  }

  :global {
    .sectionMenuList {
      &__item {
        padding: 25px 0;
        color: $color-gray-7;
        text-decoration: none;

        &:hover {
          color: $color-primary;
        }

        &.router-link-active {
          color: $color-primary;
          border-bottom: 4px solid $color-primary;
        }
        @include max-lg {
          padding: 1.25rem 0;
        }
        @include max-md {
          font-size: 0.875rem;
          padding: 0.87125rem;
        }

        &:not(:last-child) {
          position: relative;

          &::before {
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 30%;
            content: '';
            background: $color-gray-3;
            transform: translateY(-50%);
          }
        }

        &:first-child,
        &:last-child {
          position: relative;

          &::after {
            position: absolute;
            top: 50%;
            width: 1px;
            height: 30%;
            content: '';
            background: $color-gray-3;
            transform: translateY(-50%);
          }
          @include max-lg {
            &:after {
              display: none;
            }
          }
        }

        &:first-child {
          &::after {
            left: 0;
          }
        }

        &:last-child {
          &::after {
            right: 0;
          }
        }
      }

      &__BoxInner {
        position: static;
        top: -300px;
        z-index: 2001;
        @include max-lg {
          padding: 0;
        }
        @include max-md {
          position: fixed;
          top: 48px;
          z-index: 1501;
          max-width: 100vw;
          background: rgba(255, 255, 255, 0.95);
          box-shadow: 0 10px 20px rgba(33, 69, 88, 0.1);
          transition: top 0.6s;
          backdrop-filter: blur(3px);
        }
        .sectionMenuList__selectBox {
          display: none;
        }
        &.isMobileStyle {
          .sectionMenuList__list {
            @include max-sm {
              display: none;
            }
          }
          .sectionMenuList__selectBox {
            @include max-sm {
              display: block;
            }
          }
          .sectionMenuList__item {
            @include max-sm {
              &:not(:last-child) {
                &::before {
                  display: none;
                }
              }
            }
          }
        }
      }
    }

    .isFixed {
      &.sectionMenuList {
        &__BoxInner {
          position: fixed;
          top: 113px;
          z-index: 9;
          max-width: 100vw;
          // left: 0;
          // right: 0;
          background: rgba(255, 255, 255, 0.95);
          box-shadow: 0 10px 20px rgba(33, 69, 88, 0.1);
          transition: top 0.6s;
          backdrop-filter: blur(3px);

          @include max-lg {
            top: 70px;
            padding: 0;
          }
          @include max-md {
            top: 48px;
          }
        }
      }

      .sectionMenuList {
        &__list {
          max-width: 1798px;
          padding: 0 69px;
          margin: 0 auto;

          @include max-lg {
            padding: 0;
          }
        }
      }
    }
  }
  .brandCover {
    height: 381px;

    @include max-lg {
      height: 238px;
    }
    @include max-md {
      height: 54px;
    }
    :global {
      .brandCover {
        &__cover {
          position: relative;
          height: 300px;
          overflow: hidden;

          @include max-xl {
            // height: 26.4vw;
          }

          @include max-lg {
            height: 170px;
          }

          @include max-md {
            display: none;
          }
        }
        &__parallax {
          width: 100%;
          overflow: hidden;
          height: 100%;
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          // transform: translateY(-50px);
        }
        &__image {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-position: center;
          background-size: cover;
          background-color: $color-gray-2;
        }

        &__BoxInner {
          padding: 4.5rem 19px;

          @include max-lg {
            padding: 2rem 19px;
          }
        }

        &__breadcrumb {
          margin-left: -19px;
          // position: absolute;
          // bottom: 1rem;
          // left: calc(260px + 2.5rem);
          // color: #fff;

          // @include max-lg {
          //   left: calc(190px + 2.5rem);
          // }

          // @include max-md {
          //   display: none;
          // }
        }

        &__title {
          position: relative;
          z-index: 5;
          font-size: 50px;
          letter-spacing: 0.12em;
          // text-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
          color: #fff;
          @include max-lg {
            font-size: 2rem;
            letter-spacing: 0.2em;
          }

          @include max-md {
            font-size: 1.5rem;
            letter-spacing: 0.2em;
          }
        }
      }
    }
    &:global {
      &.isStyleWhite {
        .brandCover__cover {
          .brandCover__title {
            color: #3e3a39;
            text-shadow: none;
          }
        }
      }
    }
  }
}
</style>
